// extracted by mini-css-extract-plugin
module.exports = {"appButton":"styles_appButton__2g2xn","primary":"styles_primary__m1qqO","secondary":"styles_secondary__NRdDT","tertiary":"styles_tertiary___T7aa"};